const en: Record<string, string> = {
  // Navigation
  'nav.features': 'Features',
  'nav.try': 'Try',
  'nav.download': 'Download',

  // Hero
  'hero.title1': 'Discover what',
  'hero.title2': 'your dreams',
  'hero.title3': 'are telling you.',
  'hero.subtitle': 'Unlock the secrets of your subconscious in seconds. Wake up to your personal dream guide blending Islamic sources with modern AI.',

  // Features
  'features.badge': 'Features',
  'features.title1': 'Why',
  'features.title2': 'Hikmet Rüya?',
  'features.subtitle': 'The perfect blend of ancient wisdom and modern technology.',
  'features.dreamJournal.title': "Don't lose a single detail",
  'features.dreamJournal.desc': 'Capture your dreams the moment you wake up and keep your inner journey safe.',
  'features.aiInterpretation.title': 'Deep, personal meanings',
  'features.aiInterpretation.desc': 'Smart guidance that focuses on the context of your dream, not just the words.',
  'features.nightMode.title': 'Prepare for peaceful sleep',
  'features.nightMode.desc': 'Step into the night with calming content that helps your mind unwind before sleep.',
  'features.unlock': 'Unlock your dreams',

  // Dream Input
  'dreamInput.badge': 'Try Now',
  'dreamInput.title1': 'Discover',
  'dreamInput.title2': 'Your Dream',
  'dreamInput.placeholder': 'What did you see last night? Share every detail and we\'ll interpret it together...',
  'dreamInput.interpret': 'Interpret',
  'dreamInput.interpreting': 'Interpreting...',
  'dreamInput.aiTitle': 'AI Interpretation',
  'dreamInput.notDreamTitle': 'Information',
  'dreamInput.notDreamWarning': "Hello! I'm an AI that interprets dreams according to Islamic sources. 🌙 Please describe a dream you've seen, and I'll interpret it beautifully for you.",
  'dreamInput.sources': '📚 Sources:',
  'dreamInput.seeMore': '🔓 Click to See Full Interpretation',
  'dreamInput.unlockFull': 'Sign in to the app to unlock the full interpretation and more.',
  'dreamInput.error': 'An error occurred while getting the interpretation. Please try again.',
  'dreamInput.authRequired': 'You need to sign in to get dream interpretations.',
  'dreamInput.newDream': '✨ Write a New Dream',

  // Ticker
  'ticker.lucidDreaming': 'Lucid Dreaming',
  'ticker.psychology': 'Psychology',
  'ticker.astrology': 'Astrology',
  'ticker.symbolAnalysis': 'Symbol Analysis',
  'ticker.dreamJournal': 'Dream Journal',
  'ticker.aiInsights': 'AI Insights',
  'ticker.sleepPatterns': 'Sleep Patterns',
  'ticker.subconscious': 'Subconscious',
  'ticker.review1': 'I kept dreaming I was falling off a cliff. After the interpretation I faced the source of stress in my life. Incredible.',
  'ticker.review2': 'My late mother appeared in my dreams and it always unsettled me. Learning the meaning here brought me real peace.',
  'ticker.review3': 'I had the same nightmare for months. Even the first interpretation showed me what was hidden underneath.',
  'ticker.review4': 'I write down my dream right when I wake up. After a few weeks I know myself much better.',
  'ticker.review5': 'Being grounded in Islamic sources matters to me. Both traditional and modern at once.',

  // Footer
  'footer.title': 'Ready for Deeper Dreams?',
  'footer.subtitle': 'Download Hikmet Rüya and start your journey into the subconscious tonight.',
  'footer.scanToDownload': 'Scan to Download',
  'footer.startJourney': 'Start Dream Interpretation Now',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.deleteAccount': 'Delete Account',
  'footer.contact': 'Contact',
  'footer.rights': '© 2026 Hikmet Rüya. All rights reserved.',

  // Contact Dialog
  'contact.title': 'Contact',
  'contact.company': 'App',
  'contact.email': 'Email',
  'contact.description': 'Feel free to reach out with your questions, suggestions, or feedback. We will get back to you as soon as possible.',

  // Privacy Policy Dialog
  'privacy.title': 'Privacy Policy',
  'privacy.lastUpdated': 'Last Updated: 30.04.2026',
  'privacy.intro': 'Hikmet Rüya ("Application", "We") is committed to protecting the privacy of our users and securely storing personal data.',
  'privacy.acceptance': 'By downloading or using the Application, you accept the terms of this policy.',
  'privacy.section1.title': '1. DATA COLLECTED',
  'privacy.section1a.title': 'A. Information You Provide:',
  'privacy.section1a.item1.label': 'Account Information:',
  'privacy.section1a.item1.text': 'Email address, name (optional), or social media login credentials used during registration.',
  'privacy.section1a.item2.label': 'Dream Content and Journals:',
  'privacy.section1a.item2.text': 'Dream narratives entered as text or voice through "Add Dream" or "My Dream Journal" features.',
  'privacy.section1a.item3.label': 'Personalization Data:',
  'privacy.section1a.item3.text': 'Marital status, age, gender, or employment information voluntarily shared for more accurate interpretations.',
  'privacy.section1a.item4.label': 'Contact Requests:',
  'privacy.section1a.item4.text': 'Feedback and bug reports shared with our support.',
  'privacy.section1b.title': 'B. Automatically Collected Technical Data:',
  'privacy.section1b.item1.label': 'Device Information:',
  'privacy.section1b.item1.text': 'Device model, OS version (iOS/Android), screen resolution, preferred language.',
  'privacy.section1b.item2.label': 'Usage Data:',
  'privacy.section1b.item2.text': 'In-app session durations, button clicks, feature usage frequency.',
  'privacy.section1b.item3.label': 'Location Information:',
  'privacy.section1b.item3.text': 'Approximate city/district level location data required only for "Prayer Times" feature.',
  'privacy.section2.title': '2. PURPOSE OF DATA PROCESSING',
  'privacy.section2.item1': 'Generate and present AI-powered dream interpretations.',
  'privacy.section2.item2': 'Store your past dreams chronologically in "My Dream Journal".',
  'privacy.section2.item3': 'Calculate prayer times based on your location.',
  'privacy.section2.item4': 'Ensure application security and fix technical issues.',
  'privacy.section2.item5': 'Fulfill our legal obligations.',
  'privacy.section3.title': '3. DATA SHARING AND THIRD PARTIES',
  'privacy.section3.item1': 'Dream texts are processed in anonymized form for interpretation.',
  'privacy.section3.item2': 'Used for user database, authentication, and secure cloud storage of dream records.',
  'privacy.section3.item3': 'Used for in-app purchases and secure login.',
  'privacy.section3.item4.label': 'Legal Authorities:',
  'privacy.section3.item4.text': 'May be shared with official authorities in case of court order or legal obligation.',
  'privacy.section4.title': '4. DATA SECURITY AND STORAGE',
  'privacy.section4.item1.label': 'Security:',
  'privacy.section4.item1.text': 'Your data is protected with TLS/SSL and encryption methods.',
  'privacy.section4.item2.label': 'Storage Period:',
  'privacy.section4.item2.text': 'Dream records are stored as long as you do not delete your account.',
  'privacy.section4.item3.label': 'Account Deletion:',
  'privacy.section4.item3.text': 'All your data is permanently deleted within 72 hours when you delete your account.',
  'privacy.section5.title': '5. USER RIGHTS',
  'privacy.section5.item1': 'Learn whether your data is being processed.',
  'privacy.section5.item2': 'Request deletion or destruction of your data.',
  'privacy.section5.item3': 'Request correction of your data.',
  'privacy.section5.item4': 'Object to a result against you.',
  'privacy.section5.contact': 'Contact: info@ruyahikmeti.com (response within 30 days)',
  'privacy.section6.title': "6. CHILDREN'S PRIVACY",
  'privacy.section6.text': 'This application is not intended for use by children under 13.',
  'privacy.section7.title': '7. CONTACT',
  'privacy.section7.company': 'App:',
  'privacy.section7.emailLabel': 'Email:',

  // Terms of Service Dialog
  'terms.title': 'Terms of Service',
  'terms.lastUpdated': 'Last Updated: 30.04.2026',
  'terms.intro': 'These Terms of Service govern your use of the Hikmet Rüya application ("App"). By downloading the App, creating an account, or using it, you accept these terms.',
  'terms.section1.title': '1. SERVICE DESCRIPTION',
  'terms.section1.text': 'Hikmet Rüya is a mobile application where users can record their dreams and receive AI-powered interpretations grounded in Islamic sources. Interpretations are for informational purposes only and do not constitute religious, medical, or psychological advice.',
  'terms.section2.title': '2. USER ACCOUNT',
  'terms.section2.item1': 'You must be at least 13 years old to create an account.',
  'terms.section2.item2': 'You are responsible for the confidentiality of your account credentials and all activity that occurs under your account.',
  'terms.section2.item3': 'You agree not to provide false or misleading information.',
  'terms.section3.title': '3. ACCEPTABLE USE',
  'terms.section3.intro': 'You agree not to use the App to:',
  'terms.section3.item1': 'Submit unlawful, harmful, threatening, abusive, or otherwise inappropriate content.',
  'terms.section3.item2': 'Infringe the intellectual property rights of others.',
  'terms.section3.item3': 'Compromise the security of the App or attempt reverse engineering.',
  'terms.section3.item4': 'Access the system using automated tools (bots, scrapers).',
  'terms.section4.title': '4. INTELLECTUAL PROPERTY',
  'terms.section4.text': 'All text, graphics, logos, icons, images, software code, and data in the App are owned by Hikmet Rüya and protected by copyright, trademark, and other intellectual property laws. They may not be copied, distributed, or modified without written permission.',
  'terms.section5.title': '5. USER CONTENT',
  'terms.section5.text': 'Dream texts you submit to the App belong to you. However, you grant us permission to process this content in order to provide the AI interpretation and maintain the service. Your content is processed in accordance with our Privacy Policy.',
  'terms.section6.title': '6. SUBSCRIPTION & PAYMENTS',
  'terms.section6.text': 'Some features require a paid subscription. Subscriptions are managed through your Apple App Store or Google Play account. Your subscription will renew automatically unless cancelled at least 24 hours before the end of the current period. Refund requests are subject to the policies of the respective platform.',
  'terms.section7.title': '7. DISCLAIMER',
  'terms.section7.text': 'Hikmet Rüya interpretations are provided solely for informational and spiritual guidance purposes. They do not replace professional medical, psychological, or religious advice. The App is provided "as is" without any express or implied warranty of uninterrupted or error-free operation.',
  'terms.section8.title': '8. LIMITATION OF LIABILITY',
  'terms.section8.text': 'To the maximum extent permitted by applicable law, Hikmet Rüya shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the App.',
  'terms.section9.title': '9. TERMINATION',
  'terms.section9.text': 'We reserve the right to suspend or terminate your account without prior notice if you breach these Terms. You can delete your account at any time from within the App or by submitting a request to info@ruyahikmeti.com.',
  'terms.section10.title': '10. CHANGES',
  'terms.section10.text': 'We may update these Terms from time to time. Material changes will be notified within the App or by email. Continued use of the App after the update constitutes acceptance of the new Terms.',
  'terms.section11.title': '11. GOVERNING LAW',
  'terms.section11.text': 'These Terms are governed by the laws of the Republic of Türkiye. Disputes shall be resolved by the Istanbul Courts and Enforcement Offices.',
  'terms.section12.title': '12. CONTACT',
  'terms.section12.text': 'For questions: info@ruyahikmeti.com',

  // Delete Account Dialog
  'delete.title': 'Delete Account',
  'delete.intro': 'You can permanently delete your account and all associated data (dream records, profile information, settings). This action is irreversible.',
  'delete.method1.title': 'Method 1: From Within the App (Recommended)',
  'delete.method1.step1': 'Open the app and sign in.',
  'delete.method1.step2': 'Go to Profile > Settings > Account.',
  'delete.method1.step3': 'Tap "Delete Account".',
  'delete.method1.step4': 'After confirmation, your account and all data will be permanently deleted within 72 hours.',
  'delete.method2.title': 'Method 2: Email Request',
  'delete.method2.text': 'If you cannot access the app, send an email from the address associated with your account containing the following:',
  'delete.method2.item1': 'Subject: "Account Deletion Request"',
  'delete.method2.item2': 'The email address linked to your account',
  'delete.method2.item3': 'A short verification note',
  'delete.method2.email': 'Send to: info@ruyahikmeti.com',
  'delete.method2.timeline': 'Your account will be deleted within 72 hours of receiving the request, and a confirmation email will be sent.',
  'delete.deletedData.title': 'Data That Will Be Deleted',
  'delete.deletedData.item1': 'Account information (email, name)',
  'delete.deletedData.item2': 'All dream records and journal entries',
  'delete.deletedData.item3': 'Interpretation history and favorites',
  'delete.deletedData.item4': 'Settings and preferences',
  'delete.retainedData.title': 'Data That May Be Retained',
  'delete.retainedData.text': 'Some transaction records may be retained in anonymized form due to legal obligations (tax, billing, legal correspondence) under applicable data protection law.',
  'delete.contactButton': 'Send Deletion Request',

  // Phone Mockup
  'phone.dream': 'I dreamed of a bright moon in the sky and the stars were dancing...',
  'phone.aiLabel': 'AI Interpretation',
  'phone.aiResponse': 'Seeing the moon symbolizes knowledge and wisdom. A herald of a guide entering your life...',

  // Sample Interpretations
  'dreamInterpretation1': 'The water you saw in your dream symbolizes spiritual purification and renewal. According to Ibn Sirin, seeing clear water is a herald of good news. Your subconscious is reminding you of your quest for inner peace.',
  'dreamInterpretation2': 'Flying in a dream is a symbol of spiritual ascension and the quest for freedom. It shows that you have the power to overcome the obstacles you face. Your inner world whispers that you can transcend your limits.',
  'dreamInterpretation3': 'The moon you saw, according to Islamic sources, represents knowledge and wisdom. It may be a harbinger of a guide or wise person entering your life. A period that will fill your heart with light awaits you.',

  // Legal pages
  'legal.openAsPage': 'Open as a full page',
  'legal.backHome': 'Back to home',
};

export default en;
